import { Button } from '@heidi/design-system/button';
import { TypographyCaption } from '@heidi/design-system/typography';
import { useIntl } from 'react-intl';
import { navV3Messages } from '../nav-v3.messages';

interface RecentsSearchFeedbackProps {
  isError: boolean;
  retryVisits?: () => unknown;
  retryChats?: () => unknown;
}

export const RecentsSearchFeedback = ({
  isError,
  retryVisits,
  retryChats,
}: RecentsSearchFeedbackProps) => {
  const intl = useIntl();

  if (!isError) {
    return (
      <div className="px-2 py-1.5" data-testid="sidebar-recents-search-no-results">
        <TypographyCaption className="text-text-tertiary">
          {intl.formatMessage(navV3Messages.recentsSearchNoResults)}
        </TypographyCaption>
      </div>
    );
  }

  const retry = () => {
    void retryVisits?.();
    void retryChats?.();
  };

  return (
    <div className="px-2 py-1.5" data-testid="sidebar-recents-search-error">
      <TypographyCaption className="text-text-tertiary">
        {intl.formatMessage(navV3Messages.recentsSearchError)}
      </TypographyCaption>
      <Button variant="ghost" size="xs" onClick={retry}>
        {intl.formatMessage(navV3Messages.recentsSearchRetry)}
      </Button>
    </div>
  );
};
